import React from 'react';

/**
 * Desktop-only side-by-side video showcase.
 * Left: Failure / Error state video (red glow)
 * Right: Success state video (green glow)
 * Mirrors the mobile card styling (glow, rounded corners, black bg, 16:9 aspect).
 */
const DesktopVideoShowcase = () => {
  return (
    <section
      id="see-the-difference"
      className="py-16 lg:py-24 bg-[#f8f9fa] dark:bg-[#161616]"
      data-testid="desktop-video-showcase"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-20">
        {/* Optional heading */}
        <div className="text-center mb-12">
          <h2
            className="text-3xl lg:text-5xl font-bold text-[#1a1a1a] dark:text-white mb-3 tracking-tight"
            style={{ fontFamily: "'Martel Sans', sans-serif" }}
          >
            See the difference
          </h2>
        </div>

        {/* Side-by-side grid */}
        <div className="grid grid-cols-2 gap-8 lg:gap-12">
          {/* LEFT — Failure / Error video */}
          <div className="flex flex-col items-center">
            <span
              className="mb-4 text-base font-semibold tracking-wide uppercase"
              style={{ color: '#ff3b3b', fontFamily: "'Martel Sans', sans-serif" }}
            >
              Without Pluckr
            </span>

            <div
              className="relative overflow-hidden w-full"
              style={{
                aspectRatio: '16/9',
                background: '#000',
                borderRadius: '16px',
                boxShadow: '0 0 20px rgba(249, 115, 22, 0.92)',
              }}
            >
              <video
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                className="absolute inset-0 w-full h-full object-cover"
              >
                <source src="/videos/Fail.mp4" type="video/mp4" />
              </video>
            </div>
          </div>

          {/* RIGHT — Success video */}
          <div className="flex flex-col items-center">
            <span
              className="mb-4 text-base font-semibold tracking-wide uppercase"
              style={{ color: '#22c55e', fontFamily: "'Martel Sans', sans-serif" }}
            >
              With Pluckr
            </span>

            <div
              className="relative overflow-hidden w-full"
              style={{
                aspectRatio: '16/9',
                background: '#000',
                borderRadius: '16px',
                boxShadow: '0 0 20px rgba(155, 227, 143, 0.98)',
              }}
            >
              <video
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                className="absolute inset-0 w-full h-full object-cover"
              >
                <source src="/videos/Succesx - Made with Clipchamp.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DesktopVideoShowcase;
